import client from '../client';
export default {
  getPlacement: data => {
    return client.get('publisher/placement/list', { params: data }).then(res => res.data);
  },
  addPlacement: data => {
    return client.post('publisher/placement', data).then(res => res.data);
  },
  //保存Draft
  saveDraft: data => {
    return client.post('publisher/placement/draft', data).then(res => res.data);
  },

  //suspend Placement
  suspendPlacement: id => {
    return client.post(`publisher/placement/${id}/suspend`).then(res => res.data);
  },
  //更新Placement
  updatePlacement: ({id,data}) => {
    return client.put(`publisher/placement/${id}`, data).then(res => res.data);
  },
  //更新Placement Draft
  updatePlacementDraft: ({id,data}) => {
    return client.put(`publisher/placement/${id}/submit`, data).then(res => res.data);
  },
  //获取Placement详情
  getPlacementById: id => {
    return client.get(`publisher/placement/${id}`).then(res => res.data);
  },
  //下线Placement
  offlinePlacement: id => {
    return client.post(`publisher/placement/${id}/offline`).then(res => res.data);
  },
  //删除Placement
  deletePlacement: id => {
    return client.delete(`publisher/placement/${id}`).then(res => res.data);
  }
}